import { useMemo } from 'react';
import useRouteParams from './useRouteParams';
import { CRM_DYNAMIC_PAGE_REGEX, HUBDB_REGEX } from '../constants/dynamicPage';
const useDynamicPageInfo = () => {
  const {
    contentId: contentIdParam
  } = useRouteParams();
  const isMaybeDynamicPage = contentIdParam.split('-').length > 1;
  const isHubDbPage = isMaybeDynamicPage && HUBDB_REGEX.test(contentIdParam);
  const isCrmDynamicPage = isMaybeDynamicPage && CRM_DYNAMIC_PAGE_REGEX.test(contentIdParam);
  const hubDbTableId = useMemo(() => {
    if (isHubDbPage) {
      const hubDbRegExMatches = HUBDB_REGEX.exec(contentIdParam);
      return hubDbRegExMatches && hubDbRegExMatches.length > 2 ? hubDbRegExMatches[2] : '';
    }
    return '';
  }, [isHubDbPage, contentIdParam]);
  const hubDbRowId = useMemo(() => {
    if (isHubDbPage) {
      const hubDbRegExMatches = HUBDB_REGEX.exec(contentIdParam);
      const rowIdStr = hubDbRegExMatches && hubDbRegExMatches.length > 3 ? hubDbRegExMatches[3] : '0';
      try {
        return parseInt(rowIdStr, 10);
      } catch (e) {
        return 0;
      }
    }
    return 0;
  }, [isHubDbPage, contentIdParam]);
  const crmObjectTypeId = useMemo(() => {
    if (isCrmDynamicPage) {
      const crmDynamicPageRegExMatches = CRM_DYNAMIC_PAGE_REGEX.exec(contentIdParam);
      return crmDynamicPageRegExMatches && crmDynamicPageRegExMatches.length > 3 ? `${crmDynamicPageRegExMatches[2]}-${crmDynamicPageRegExMatches[3]}` : '';
    }
    return '';
  }, [contentIdParam, isCrmDynamicPage]);
  const crmObjectId = useMemo(() => {
    if (isCrmDynamicPage) {
      const crmDynamicPageRegExMatches = CRM_DYNAMIC_PAGE_REGEX.exec(contentIdParam);
      return crmDynamicPageRegExMatches && crmDynamicPageRegExMatches.length > 4 ? crmDynamicPageRegExMatches[4] : '';
    }
  }, [contentIdParam, isCrmDynamicPage]);
  return {
    crmObjectTypeId,
    crmObjectId,
    isHubDbPage,
    isCrmDynamicPage,
    hubDbRowId,
    hubDbTableId
  };
};
export default useDynamicPageInfo;